function Loading({}: any) {
  return <div>Loading...</div>;
}

export default Loading;
